// extracted by mini-css-extract-plugin
export default {"cls1":"_rOraNMlfTdn5y89LGQj","cls2":"Kpubp5bgomh0Qxkej9Rd _rOraNMlfTdn5y89LGQj"};